import { Button, Modal } from '@mui/material'
import React from 'react'
import ReactPlayer from 'react-player'
import '../styles/recordings1v1.css';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import CloseIcon from '@mui/icons-material/Close';
const Recordings1v1 = ({open,handleClose,currentRecordings}:{open:boolean,handleClose:any,currentRecordings:any}) => {
  return (
    <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
		aria-describedby="modal-modal-description"
        >
            <div className={'modal recordings1v1Modal'}>

            <button
									className={'close-btn'}
									onClick={handleClose}
								>
									<CloseIcon />
								</button>
                <OwlCarousel className='owl-theme' items={1}  nav>
                    {currentRecordings.map((recording:any)=>{
                        return(
                            <div className='item'>
                                <ReactPlayer
					url={recording}
					controls={true}
					config={{
						vimeo: {
							playerOptions: {
								pip: true,
							},
						},
					}}
					width={640}
					style={{
						position: 'relative',
						display: 'flex',
						justifyContent: 'center',
						marginInline: 'auto',
						borderRadius: '5px',
						overflow: 'hidden',
						background: 'black',
					}}
					showTitle={false}
				/>
                            </div>
                        )
                    })}
                </OwlCarousel>
            </div>
    </Modal>
  )
}

export default Recordings1v1